module.exports = __webpack_public_path__ + "static/img/chance.aec1fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s29/chance.png
// module id = M3Zs
// module chunks = 2